<svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="28.8889" height="9.77778" viewBox="0 0 28.8889 9.77778" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="Vector 4" d="M28.4444 0.444444H9.33333L0.444444 9.33333" stroke="white" stroke-width="0.888889" stroke-linecap="round"/>
</svg>
